/**
 * 后端 API 客户端
 */

import type { AnyGenerateResponse, GenerateRequest } from "../shared/types";

export async function generateMonsters(req: GenerateRequest, signal?: AbortSignal): Promise<AnyGenerateResponse> {
  const controller = signal ? null : new AbortController();
  const sig = signal ?? controller!.signal;

  const timeout = setTimeout(() => {
    if (controller) controller.abort();
  }, 60_000);

  try {
    const res = await fetch("/api/generate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
      signal: sig,
    });
    const data: AnyGenerateResponse = await res.json();
    return data;
  } catch (err) {
    if ((err as Error).name === "AbortError") {
      return { ok: false, error: "请求超时", code: "TIMEOUT" };
    }
    return { ok: false, error: "网络错误", code: "LLM_FAILED" };
  } finally {
    clearTimeout(timeout);
  }
}
